// Libraries
import {
    memo, useContext, useEffect, useMemo, 
    useState
} from 'react';
import {
    useTheme 
} from '@mui/material';

// Utils
import {
    createEmailSkip, createIntroSkip 
} from '../../config/utils';

// Config
import {
    defaultSignupSections,
    DiagnosticFormContext 
} from '../../../../contexts/form';
import {
    useCookies 
} from 'react-cookie';

// Components
import SCREENS from './sections';

// v2 of new diagnostic
// moved up email and name submission

type Props = {
    index: number;
};

export default memo(function DiagnosticForm2024090901({
    index = 0 
}: Props) {
    const diagnosticFormContext = useContext(DiagnosticFormContext);
    const theme = useTheme();
    const [cookies] = useCookies();
    const [isLoading, setIsLoading] = useState(true);
    const skippySkipsIntro = useMemo(() => createIntroSkip(diagnosticFormContext, 30), [diagnosticFormContext]);
    const skippySkipsEmail = useMemo(() => createEmailSkip(diagnosticFormContext, 29), [diagnosticFormContext]);

    // Set initial values and functions in context
    useEffect(() => {
        diagnosticFormContext.skippySkipsIntro = skippySkipsIntro;
        diagnosticFormContext.skippySkipsEmail = skippySkipsEmail;

        diagnosticFormContext.sections = [
            {
                key: 'intro',
                headerText: 'Your Goals',
                length: 1,
                colors: {
                    background: theme.palette.white,
                    main: theme.palette.transparent,
                    headerText: theme.palette.transparent,
                    choiceText: theme.palette.transparent,
                    choice: theme.palette.transparent,
                    ctaBackground: theme.palette.transparent,
                    ctaButton: theme.palette.transparent,
                    ctaButtonText: theme.palette.transparent,
                    ctaText: theme.palette.transparent,
                    buttonArrow: theme.palette.black,
                    circleTakeover: theme.palette.transparent
                },
                icon: <></>,
                inProgressBar: false
            },
            ...defaultSignupSections
        ];
        diagnosticFormContext.sections[1].length = 8;
        diagnosticFormContext.sections[2].length = 20;
        diagnosticFormContext.sections[3].length = 5;
        diagnosticFormContext.sections[4].length = 30;
        setIsLoading(false);
    }, []);

    useEffect(() => {
        const trackingName = screens[index].trackingName;
        const screenName = screens[index].screenName;

        if (trackingName) diagnosticFormContext.fireTrackingEvents(diagnosticFormContext, trackingName, cookies);
        if (screenName) diagnosticFormContext.currentScreenName = screenName;
    }, [index]);

    const screens = useMemo(() => ([
        ...SCREENS.INTRO_SCREENS,
        ...SCREENS.GOALS_SCREENS_V2,
        ...SCREENS.HABITS_SCREENS_V2,
        ...SCREENS.ABOUT_YOU_SCREENS_V2,
        ...SCREENS.PLAN_SCREENS,
        ...SCREENS.CHECKOUT_SCREENS
    ]), []);

    if (isLoading) return <></>;

    return (
        <>
            {screens[index].component}
        </>
    );
});
